<template>
  <span v-if="hasInvoices">
    <el-dropdown id="more-actions-dropdown" v-show="!isInBulkPrintingInvoices && !isInUploadToVersapay">
      <el-button class="button-more-actions" type="success" plain size="mini">{{ $t('common.moreActions') }}<i class="el-icon-arrow-down el-icon--right" /></el-button>
      <el-dropdown-menu slot="dropdown">
          <print-invoice-bulk :is-drop-down-item="true" />
          <post-invoices-dialog />
         <export-to-csv :is-drop-down-item="true" />
          <upload-to-versapay :is-drop-down-item="true" />
      </el-dropdown-menu>
    </el-dropdown>
    <span v-show="isInBulkPrintingInvoices">
        <print-invoice-bulk/>
    </span>
    <span v-show="isInUploadToVersapay">
        <upload-to-versapay />
    </span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import ExportToCsv from '@/views/customerService/components/ExportToCsv';
import PrintInvoiceBulk from '@/views/customerService/components/PrintInvoiceBulk';
import UploadToVersapay from '@/views/customerCenter/invoices/components/UploadToVersapay';
import PostInvoicesDialog from './PostInvoicesDialog';

export default {
  name: 'MoreActions',
  components: {
    ExportToCsv,
    UploadToVersapay,
    PostInvoicesDialog,
    PrintInvoiceBulk
  },
  data() {
    return {};
  },
  computed: {
    apiConstants() {
      return apiConstants;
    },
    ...mapGetters([
      'hasInvoices',
      'isInBulkPrintingInvoices',
      'isInUploadToVersapay'
    ])
  },
  methods: {
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#more-actions-dropdown {
  padding-bottom: 5px;
}
.button-more-actions  {
  margin-left: 5px;
}

.more-actions-option {
  color: #008d00;
}
</style>
